import React, { useState } from 'react'
import ReactMarkdown from 'react-markdown';
import { Checkbox, ControlLabel, FormGroup, Modal, Button, Well } from 'react-bootstrap';

const CriticalContract = ({ contract, contractAccepted }) => {
  const [showModal, setShowModal] = useState(false)
  const [accepted, setAccepted] = useState(false)
  const [submitDisabled, setSubmitDisabled] = useState(true)

  const handleContractClicked = (e) => {
    if (accepted){
      setAccepted(false)
      contractAccepted(false)
    } else {
      e.preventDefault()
      setShowModal(true)
    }
  }

  const checkAllRead = (e) => {
    let target = e.target.scrollHeight - e.target.clientHeight - 20
    if (e.target.scrollTop >= target){
      setSubmitDisabled(false)
    } else {
      setSubmitDisabled(true)
    }
  }

  const accept = () => {
    setAccepted(true)
    contractAccepted(true)
    setShowModal(false)
    setSubmitDisabled(true)
  }

  const modal = () => (
    <Modal id={`contract_${contract.id}_modal`} show={showModal} onHide={() => setShowModal(false)}>
      <Modal.Header closeButton>
        <Modal.Title>{contract.title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Well
          id={`contract_${contract.id}_well`}
          onScroll={checkAllRead}
          style={{ maxHeight: 500, overflow: 'scroll' }}>
          <ReactMarkdown source={contract.content.replace(/href=/g, 'target="_blank" href=')} />

          <div style={{ textAlign: 'center' }}>
            <Button
              className="btn-primary btn-lg"
              onClick={e => accept()}
              disabled={submitDisabled}>
              Accept
            </Button>
          </div>
        </Well>
        <div style={{ textAlign: 'center' }}>
          <ReactMarkdown source={'Please read the contract and press Accept at the bottom'} />
        </div>
      </Modal.Body>
    </Modal>
  )

  return(
    <>
      <FormGroup style={{ margin: 0 }}>
        <Checkbox
          id={contract.id}
          checked={accepted}
          style={{ display: 'inline-block', margin: 0 }}
          onChange={(e) => { handleContractClicked(e) }}>
          Check here to read and accept our <strong>{contract.title}</strong>
        </Checkbox>
      </FormGroup>
      {modal()}
    </>
  )
}

export default CriticalContract
